import React, { useEffect, useState } from "react";
import "../../style/form/tabs/basetimeform.scss";
import { basetime } from "../../../text/apidata";
import axios from "axios";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { TimeField } from "@mui/x-date-pickers/TimeField";
import { SingleInputTimeRangeField } from "@mui/x-date-pickers-pro/SingleInputTimeRangeField";
import { useDispatch, useSelector } from "react-redux";
import Button from "@mui/material/Button";
import { basetimeedit, basetimeid } from "../../redux/reducer/counterslice";
import Swal from "sweetalert2";

function BaseTimeForm(props) {
  var date = new Date(),
    mnth = ("0" + (date.getMonth() + 1)).slice(-2),
    day1 = ("0" + date.getDate()).slice(-2);
  var date = [date.getFullYear(), mnth, day1].join("-");
  const [currentdate, setcurrentdate] = useState(date);

  const [value, setValue] = useState([
    dayjs(currentdate + "T" + "00:00:00"),
    dayjs(currentdate + "T" + "00:00:00"),
  ]);
  const [value1, setValue1] = useState([
    dayjs(currentdate + "T" + "00:00:00"),
    dayjs(currentdate + "T" + "00:00:00"),
  ]);

  // console.log(value);
  const [duration, setduration] = useState(
    dayjs(currentdate + "T" + "00:00:00")
  );
  const [day, setDay] = useState("");
  const [doctorid, setdoctorid] = useState("");
  const [timerange, settimerange] = useState(false);
  const [timeerror, settimeerror] = useState(false);
  const activebtf = useSelector((state) => state.counter.basetimeedit);
  const id = useSelector((state) => state.counter.basetimeid);
  const [alert, setalert] = useState(false);

  const dispatch = useDispatch();
  // console.log(duration);
  const routehead = useNavigate();

  const cancelnewuser = () => {
    if (alert) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, revert it!",
      }).then((result) => {
        if (result.isConfirmed) {
          //Swal.fire("Reverted!", "Given Info has been Removed.", "success");
          dispatch(basetimeedit(""));
          setalert(false);
        }
      });
    } else {
      dispatch(basetimeedit(""));
      setalert(false);
    }
  };

  useEffect(() => {
    if (activebtf == "btfactive") {
      axios({
        method: "get",
        url: basetime + id + "/",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token") + "",
        },
      })
        .then((res) => {
          setDay(res.data.data.day);
          setdoctorid(res.data.data.doctor);
          setValue([
            dayjs(currentdate + "T" + res.data.data.start_time),
            dayjs(currentdate + "T" + res.data.data.end_time),
          ]);
          setduration(dayjs(currentdate + "T" + res.data.data.duration));
        })
        .catch((error) => {
          console.log(error);
          props.popupalert("true");
          props.popuptext(error.response.data.status.message);
          setTimeout(() => {
            props.popupalert("false");
          }, 2000);
          props.loaderchange("false");
        });
    }
  }, [activebtf, id]);

  const updatebasetime = (e) => {
    var tzoffset = new Date().getTimezoneOffset() * 60000; //offset in milliseconds
    console.log(
      new Date(value[0].$d - tzoffset).toISOString().slice(-13, -5),
      new Date(value[1].$d - tzoffset).toISOString().slice(-13, -5)
    );
    if (
      new Date(value[0].$d - tzoffset).toISOString().slice(-13, -5) &&
      new Date(value[1].$d - tzoffset).toISOString().slice(-13, -5) !=
        "00:00:00"
    ) {
      var localISOTime = new Date(value[0].$d - tzoffset)
        .toISOString()
        .slice(-13, -5);
      // console.log(new Date(value[0].$d - tzoffset).toISOString().slice(-13, -5));
      var data = {
        day: day,
        start_time: new Date(value[0].$d - tzoffset)
          .toISOString()
          .slice(-13, -5),
        end_time: new Date(value[1].$d - tzoffset).toISOString().slice(-13, -5),
        duration: new Date(duration.$d - tzoffset).toISOString().slice(-13, -5),
        doctor: doctorid,
      };

      if (activebtf == "btfactive") {
        props.loaderchange("true");
        axios({
          method: "put",
          data: data,
          url: basetime + id + "/",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token") + "",
          },
        })
          .then((res) => {
            dispatch(basetimeedit(""));
            window.location.href = "/DoctorView";
            props.loaderchange("false");
          })
          .catch((error) => {
            console.log(error);
            props.popupalert("true");
            props.popuptext(error.response.data.status.message);
            setTimeout(() => {
              props.popupalert("false");
            }, 2000);
            props.loaderchange("false");
          });
      }
    } else {
      if (
        new Date(value[0].$d - tzoffset).toISOString().slice(-13, -5) &&
        new Date(value[1].$d - tzoffset).toISOString().slice(-13, -5) ==
          "00:00:00"
      ) {
        settimerange(true);
      }
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
  };

  return (
    <>
      <div className="adminform1">
        <div class="modal-dialog1" role="document">
          <div class="modal-content1">
            <div class="modal-header">
              <h5 class="modal-title">
                {" "}
                {day == 0
                  ? "BaseTime Edit -" + "Monday"
                  : day == 1
                  ? "BaseTime Edit -" + "Tuesday"
                  : day == 2
                  ? "BaseTime Edit -" + "Wednesday"
                  : day == 3
                  ? "BaseTime Edit -" + "Thursday"
                  : day == 4
                  ? "BaseTime Edit -" + "Friday"
                  : day == 5
                  ? "BaseTime Edit -" + "Saturday"
                  : day == 6
                  ? "BaseTime Edit -" + "Sunday"
                  : ""}
              </h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={(e) => cancelnewuser(e)}
              >
                <i class="bi bi-x-lg"></i>
              </button>
            </div>
            <div class="modal-body">
              <div className="maincontainer-BaseTimeForm">
                <div className="parent-BaseTimeForm">
                  <div className="create-BaseTimeForm card">
                    <form
                      style={{ padding: "0rem 0rem 0rem 0rem" }}
                      className="formspace"
                      onSubmit={handleSubmit}
                    >
                      <div
                        class="form-row"
                        style={{
                          display: "flex",
                          flexFlow: "row wrap",
                          placeContent: "center space-between",
                          alignItems: "center",
                        }}
                      >
                        <div class="form-group col-md-6 p-2 ">
                          <label
                            for="validationCustom01"
                            class="form-label"
                            style={{ padding: "5px", margin: 0 }}
                          >
                            StartTime-EndTime
                          </label>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DemoContainer
                              components={["SingleInputTimeRangeField"]}
                            >
                              <SingleInputTimeRangeField
                                // format="HH:mm:ss"
                                variant="outlined"
                                error={timerange}
                                inputProps={{
                                  style: { fontSize: 12 },
                                  autoComplete: "off",
                                }}
                                InputLabelProps={{ style: { fontSize: 12 } }}
                                style={{ minWidth: "100%" }}
                                sx={{
                                  m: 0,
                                  width: "100%",
                                  border: "none",
                                  padding: "6px",
                                  paddingLeft: "0px",
                                  "& label.Mui-focused": {
                                    color: "white",
                                  },
                                  "& .MuiInput-underline:after": {
                                    borderBottomColor: "#ced4da",
                                  },
                                  "& .MuiOutlinedInput-root": {
                                    margin: "4px",
                                    "& fieldset": {
                                      borderColor: "#ced4da",
                                    },
                                    "&:hover fieldset": {
                                      borderColor: "#ced4da",
                                    },
                                    "&.Mui-focused fieldset": {
                                      boxShadow:
                                        "0 0 0 0.25rem rgba(13, 110, 253, 0.25)",
                                      border: "none",
                                    },
                                  },
                                }}
                                value={value}
                                onError={() => settimerange(true)}
                                onChange={(newValue) => {
                                  setalert(true);

                                  if (newValue == value1) {
                                    // alert("swdw");
                                  }
                                  var timestamp1 = new Date(value[1].$d);
                                  var timestamp2 = new Date(value[0].$d);

                                  // Calculate the time difference in milliseconds
                                  var timeDifferenceMs =
                                    timestamp2 - timestamp1;
                                  console.log(timeDifferenceMs);
                                  // Convert milliseconds to hours
                                  var intervalHours =
                                    timeDifferenceMs / (1000 * 60 * 60);

                                  console.log(
                                    "Interval time in hours:",
                                    intervalHours
                                  );
                                  setValue(newValue);
                                  settimerange(false);
                                }}
                                // helperText={
                                //   timerange ? "Enter Proper Time Range " : ""
                                // }
                              />
                            </DemoContainer>
                          </LocalizationProvider>
                        </div>
                        <div class="form-group col-md-6 p-2">
                          <label
                            for="validationCustom01"
                            class="form-label"
                            style={{ padding: "5px", margin: 0 }}
                          >
                            Duration
                          </label>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DemoContainer components={["TimeField"]}>
                              <TimeField
                                value={duration}
                                error={timeerror}
                                onChange={(newValue) => {
                                  // console.log(newValue.$d,":;;;;")
                                  setalert(true);

                                  setduration(newValue);
                                  var tzoffset =
                                    new Date().getTimezoneOffset() * 60000; //offset in milliseconds
                                  if (
                                    newValue &&
                                    newValue.$d != "Invalid Date" &&
                                    newValue.$d != null
                                  ) {
                                    var localISOTime = new Date(
                                      newValue.$d - tzoffset
                                    )
                                      .toISOString()
                                      .slice(-13, -5);
                                    console.log(
                                      newValue,
                                      localISOTime,
                                      ":::::"
                                    );
                                  }
                                  if (localISOTime == "00:00:00") {
                                    settimeerror(true);
                                  } else {
                                    settimeerror(false);
                                  }
                                }}
                                style={{
                                  minWidth: "100%",
                                  overflow: "unset",
                                }}
                                sx={{
                                  m: 0,
                                  width: "100%",
                                  border: "none",
                                  padding: "6px",
                                  paddingLeft: "0px",
                                  "& label.Mui-focused": {
                                    color: "white",
                                  },
                                  "& .MuiInput-underline:after": {
                                    borderColor: "#ced4da",
                                    borderBottomColor: "#ced4da",
                                  },
                                  "& .MuiOutlinedInput-root": {
                                    margin: "4px",

                                    borderColor: "#ced4da",
                                    "& fieldset": {
                                      borderColor: "#ced4da",
                                    },
                                    "&:hover fieldset": {
                                      borderColor: "#ced4da",
                                    },
                                    "&.Mui-focused fieldset": {
                                      boxShadow:
                                        "0 0 0 0.25rem rgba(13, 110, 253, 0.25)",
                                      border: "none",
                                    },
                                  },
                                }}
                                format="HH:mm:ss"
                                variant="outlined"
                                onError={() => settimeerror(true)}
                                inputProps={{
                                  style: { fontSize: 12 },
                                  autoComplete: "off",
                                }}
                                InputLabelProps={{ style: { fontSize: 12 } }}
                                helperText={
                                  timeerror ? "Enter Proper Time" : ""
                                }
                              />
                            </DemoContainer>
                          </LocalizationProvider>
                        </div>
                      </div>
                      <div
                        class="form-row"
                        style={{
                          display: "flex",
                          flexFlow: "row wrap",
                          placeContent: "center space-between",
                          alignItems: "center",
                        }}
                      >
                        <div
                          class="form-group col-md-12 "
                          style={{ margin: 0, padding: 0 }}
                        >
                          <button
                            type="submit"
                            class="btn btn-primary  create"
                            onClick={(e) => updatebasetime(e)}
                          >
                            Update BaseTime
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default BaseTimeForm;
